import { requestPostPromoCode } from "@/state/offices/OfficesEffects";
import { toastError, toastSuccess } from "@/utils/helpers/toast-helper";
import { Input } from "antd";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "@components/core/layouts/Loader";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";

interface PromotionCodeModalProps extends BasicModalProps {
  officeId: string;
}

const PromotionCodeModal: FunctionComponent<PromotionCodeModalProps> = ({
  officeId,
  ...props
}) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [promoCode, setPromoCode] = useState<string>("");

  const tryPromoCode = () => {
    requestPostPromoCode({ id: officeId, dto: { code: promoCode } })
      .then((response) => {
        if (response.ok) {
          toastSuccess(
            t("offices.balanceAndStatistics.promoCodeModal.success"),
          );
        } else {
          toastError(t("offices.balanceAndStatistics.promoCodeModal.failed"));
        }
      })
      .catch(() =>
        toastError(t("offices.balanceAndStatistics.promoCodeModal.failed")),
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <BasicModal
      title={t("offices.balanceAndStatistics.promoCode")}
      onOk={tryPromoCode}
      buttonText={t("offices.balanceAndStatistics.promoCodeModal.use")}
      {...props}
    >
      <div>
        {isLoading ? (
          <Loader className="w-75 mt-4 mb-2 ml-auto mr-auto" />
        ) : (
          <Input
            className="form-control w-75 mt-4 mb-2 ml-auto mr-auto"
            placeholder={t(
              "offices.balanceAndStatistics.promoCodeModal.placeholder",
            )}
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
          />
        )}
      </div>
    </BasicModal>
  );
};

export default PromotionCodeModal;
